import { render, staticRenderFns } from "./CardInstitution.vue?vue&type=template&id=408b5c7c&scoped=true"
import script from "./CardInstitution.vue?vue&type=script&lang=js"
export * from "./CardInstitution.vue?vue&type=script&lang=js"
import style0 from "./CardInstitution.vue?vue&type=style&index=0&id=408b5c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408b5c7c",
  null
  
)

export default component.exports